var bootstrap = require('./bootstrap');
//var pdfMake = require('pdfmake/build/pdfmake.js');
//var pdfFonts = require('pdfmake/build/vfs_fonts.js');
//pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Ini Datatables
var dTables = require('datatables.net-bs4');
var dTAutoFill = require('datatables.net-autofill-bs4');
var dTButtons =require('datatables.net-buttons-bs4');
var dTScroller = require('datatables.net-scroller-bs4');
var dTColVis = require('datatables.net-buttons/js/buttons.colVis.js');
var dTHtml5 = require('datatables.net-buttons/js/buttons.html5.js');
var dTButtonsPrint = require('datatables.net-buttons/js/buttons.print.js');
var dTresposive = require('datatables.net-responsive-bs4');
var dTPluginProcessing = require('datatables.net-plugins/api/processing()');
// End Datatables

var datepicker = require('bootstrap-datepicker');
var datetimepicker = require('pc-bootstrap4-datetimepicker');
var tooltipster = require('tooltipster');
var tooltipsterFollower = require('tooltipster-follower');
window.SimpleBar = require('simplebar');
var loading = require('jquery-easy-loading');
var loadingOverlay = require('gasparesganga-jquery-loading-overlay');

window.moment = require('moment');
var select2 = require('select2');
var chart = require('chart.js');
window.numbro = require('numbro');
window.Plyr = require('plyr');
window.bootbox = require('bootbox');
window.PNotify = require('pnotify/dist/umd/PNotify');
window.PNotifyButtons = require('pnotify/dist/umd/PNotifyButtons');
window.screenfull = require('screenfull');
window.iframeResizer = require('iframe-resizer');
var validate = require('jquery-validation');
var $ = require('jquery');
var hoverIntent = require('jquery-hoverintent');
var easing = require('jquery.easing');

//rangeslider
var rangeslider = require('rangeslider.js');

//star rating
var rating = require('bootstrap-star-rating');

window.inputmask = require('inputmask/dist/min/jquery.inputmask.bundle.min.js');